import React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'

import { colors } from '@lmc/common/constants'
import { IconButton } from '../../../../../../components/generic'
import { Popover } from '@lmc/ui-kit'

export default function DisabledPDFButton() {
  return (
    <Popover
      arrowPointAtCenter
      content={
        <div style={styles.disabledPDF}>
          <div>Max date interval for the PDF is 14 days or less.</div>
          <div>Please adjust and try again.</div>
        </div>
      }
      placement="bottom"
    >
      <div>
        <IconButton icon="pdf" disabled>
          {isDesktop ? 'Download PDF' : 'PDF'}
        </IconButton>
      </div>
    </Popover>
  )
}

const isDesktop = isBrowser || isTablet

const styles = {
  disabledPDF: {
    background: colors.white,
    borderRadius: 4,
    color: colors.black,
    lineHeight: '22px',
    padding: '8px 16px',
    textAlign: 'center',
  },
}
